module.exports = __webpack_public_path__ + "img/sweet_stop.93afc61d.png";